<template>
    <div class="relative">
        <input type="hidden" :name="name" :value="formattedDates" readonly/>
        <date-picker
            mode="range"
            v-model="dates"
            color="gray"
            :columns="$screens({ default: 1, lg: 2 })"
            :min-date="new Date()"
            @input="$emit('change', dates)"
            @click="handleClick($event)"
            data="YYYY-MM-DD"
            :input-props="{ readonly: 'readonly' }">
        </date-picker>
    </div>
</template>

<script>
export default {
    name: "inline-date-picker",
    props: ["name", "value"],

    data: () => ({
        dates: null,
    }),

    mounted() {
        if(this.value != '') {
            const splittedDates = this.value.split('--');
            this.dates = {
                start: new Date(splittedDates[0].trim()),
                end: new Date(splittedDates[1].trim())
            }
        }
    },

    methods: {
        handleClick(event) {
            event.target.blur();
        }
    },

    computed: {
        formattedDates() {
            if (this.dates === null) {
                return this.value;
            }
            return `${this.format(this.dates.start)}--${this.format(this.dates.end)}`;
        }
    },

    methods: {
        format(date) { // YYYY-MM-DD
            return date.getFullYear()
                + '-' + this.makeItTwoDigits(date.getMonth() + 1)
                + '-' + this.makeItTwoDigits(date.getDate());
        },
        makeItTwoDigits(str) {
            return ('0' + str).slice(-2);
        }
    },
};
</script>
